import { render, staticRenderFns } from "./ModalEditProduct.vue?vue&type=template&id=1f9a1df2"
import script from "./ModalEditProduct.vue?vue&type=script&lang=js"
export * from "./ModalEditProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports